<style scoped lang="stylus">
.home-btn
  display flex
  justify-content center
  align-items center
  position fixed
  bottom 40px
  right 14px
  width 44px
  height 44px
  font-size 24px
  border-radius 100%
  background rgba(255, 255, 255, 0.9)
  box-shadow: 0 0.7px 2.5px rgba(0, 0, 0, 0.02), 0 1.6px 16px rgba(0, 0, 0, 0.028), 0 3px 11.3px rgba(0, 0, 0, 0.035), 0 5.4px 20.1px rgba(0, 0, 0, 0.042), 0 10px 37.6px rgba(0, 0, 0, 0.05), 0 24px 90px rgba(0, 0, 0, 0.07)
</style>

<template>
	<div class="home-btn" :class="icon" :style="{ zIndex }" @click="goHome"></div>
</template>

<script>
export default {
	name: 'homeBtn',
	props: {
		icon: {
			type: String,
			default: 'adv-location-25d'
		},
		path: {
			type: String,
			default: '/'
		},
		zIndex: {
			type: [String, Number],
			default: 1000
		}
	},
	methods: {
		// 回到首页
		goHome() {
			this.$router.replace(this.path)
			// 待实现：返回首页，并清除其它路由
			// let backlen = history.length - 1
			// history.go(-backlen)
		}
	}
}
</script>
